export const normalizeBaseUrl = (baseUrl: string): string => {
  if (!baseUrl) return '';
  // Ensure trailing slash
  let url = baseUrl.trim();
  if (!url.endsWith('/')) url += '/';
  return url;
};

export const getPublicStandUrl = (standId: string, baseUrl: string): string => {
  const normalized = normalizeBaseUrl(baseUrl);
  // If baseUrl already includes 'stand/' keep it, otherwise append
  if (/stand\/$/.test(normalized)) {
    return normalized + standId;
  }
  return normalized + 'stand/' + standId;
};
